import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'inverted' | 'plain';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  block?: boolean;
  loading?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    children,
    variant = 'primary',
    size = 'md',
    block,
    loading,
    disabled,
    startIcon,
    endIcon,
    className = '',
    type = 'button',
    ...rest
  },
  ref,
) {
  const cls = [
    styles.btn,
    styles[`v_${variant}`],
    styles[`s_${size}`],
    block ? styles.block : '',
    loading ? styles.loading : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button ref={ref} type={type} className={cls} disabled={disabled || loading} {...rest}>
      {startIcon && <span className={styles.icon}>{startIcon}</span>}
      <span className={styles.label}>{children}</span>
      {endIcon && <span className={styles.icon}>{endIcon}</span>}
      {loading && <span className={styles.spinner} aria-hidden />}
    </button>
  );
});
